import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textSection" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon-schliessen" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import { useGlobalStore } from "@/stores/GlobalStore";
import { computed } from "vue";
import { ErrorType, ErrorLocationType } from "@/utilities/enums/Enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
    errorLoc: ErrorLocationType,
},
  setup(__props) {

const props = __props



const globalStore = useGlobalStore();

const show = computed(()=> props.errorLoc === globalStore.error.location);

const closeError = ()=>{
    globalStore.error.location = ErrorLocationType.none;
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['contextError', _unref(globalStore).error.type === _unref(ErrorType).warning ? 'warningType' : 'errorType'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(globalStore).error.text), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", { class: "buttonSection" }, [
      _createElementVNode("div", {
        type: "button",
        class: "errorCloseButton",
        onClick: closeError
      }, _hoisted_4)
    ])
  ], 2)), [
    [_vShow, _unref(show)]
  ])
}
}

})